<template>
  <div class="bg-white">
    <CoverPage />
    <div class="container md:px-12 px-6">
      <AboutComp />
      <InternshipPosi />
      <OpenPosi />
    </div>
    <div class="bge3ceff-opa rounded-t-5555 mt-12">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import CoverPage from "./components/CoverPage.vue";
import AboutComp from "./components/AboutComp.vue";
import OpenPosi from "./components/OpenPosi.vue";
import InternshipPosi from "./components/InternshipPosi.vue";
import DownloadApp from "../home/components/DownloadApp.vue";
import Footer from "../Footer.vue";
export default {
  components: {
    CoverPage,
    AboutComp,
    OpenPosi,
    DownloadApp,
    Footer,
    InternshipPosi,
  },
  metaInfo: {
    title: "Careers at Caregiver Saathi",
    meta: [
      {
        name: "keyword",
        content:
          "Caregiver caregiving, agencies for caregivers,agencies for home care,assisted home care services,home care agency,home care for elderly,home care for seniors,at home nurse care,at home senior care services,care for the caregiver program,caregiver burden,wellness,well-being,health and well-being,mental health,physical health,psychological wellbeing,caregiver needs,caregiver burnout,caregiver stress,family caregiver,caregiver companion,respite care,attendant,patient support,nursing services,caregiving services,caregiver websites,Caregiving training,Caregiver support,Caregiving for specific needs,Caregiving training near me,Caregivers for seniors,Caregiving agencies,caregiving agencies in Mumbai,Caregiving and compassionate reasons,Caregiving for healthcare professionals,counselling,therapy,coaching,caregiver coaching,palliative care,caregiving support for cancer patient,attendant for dementia patient,helpline for caregiving,grief support group,volunteering,volunteering opportunities in India,grief management,employee well-being,corporate services,online forum for caregiver,community for caregivers,bhavana Issar,online learning,care management,caregiving courses,",
      },
      {
        name: "description",
        content:
          "Interested in a career in social sector? We are in the lookout for passionate professionals to drive our cause.Mail your resume to info@caregiversaathi.co.in",
      },
    ],
  },
};
</script>
